import styled from "styled-components";

export const ContentBannerPurpleMetrics = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ImageBannerPurpleMetrics = styled.img`
  border-radius: 8px;
  object-fit: cover;
  width: 300px;
  height: 300px;

  @media (max-width: 768px) {
    width: 100%;
    object-fit: fill;
    height: 350px;
  }
`;

export const LinkPurpleMetrics = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
